import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import TeamLeader from "./Flows/TeamLeader/TeamLeader";
import Student from "./Flows/Student/Student";
import TeamMember from "./Flows/TeamMember/TeamMember";
import ClubAdmin from "./Flows/ClubAdmin/ClubAdmin";
import SuperAdmin from "./Flows/SuperAdmin/SuperAdmin";
import Trainer from "./Flows/ClubTrainer/Trainer";
import Landing from "./landing/Landing";
import ProtectedRoute from "./components/ProtectedRoutes/ProtectedRoutes";
import ContactUs from "./pages/ContactUs";
import Disclaimer from "./pages/Disclaimer";
import TermsAndConditions from "./pages/TermsAndCondition";
import RefundPolicy from "./pages/RefundPolicy";
import NotFound from "./landing/NotFound/NotFound";
import CoursePage from "./pages/CoursePage";
import ProductPage from "./pages/ProductPage";
import LmsPackageDetails from "./pages/Lms_package_details";
import LmsBatchDetails from "./pages/Lms_batch_details";
import LmsCourseDetails from "./pages/Lms_course_details";
import LmsModuleDetails from "./pages/Lms_module_details";
import MainLayout from "./layouts/MainLayout";
import Transactions from "./components/AdminComponents/Transactions/Transactions";
import SuperAdminLayout from "./layouts/SuperAdminLayout";
import Payments from "./components/AdminComponents/Payments/Payments";
import SuperDa from "./Flows/SuperAdmin/Dashboard/SuperDash/SuperDashboard";
import CourseList from "./components/AdminComponents/CourseList/Couselist";
import Lms from "./components/AdminComponents/Lms/Lms";
import Gift from "./components/AdminComponents/Gift/Gift";
import SalesTarget from "./Flows/SuperAdmin/Dashboard/SaleTarget/SaleTarget";
import StudentRegister from "./components/AdminComponents/AddTeamLeader/AddTeamLeader";

import SuperAdminSignin from "./Flows/SuperAdmin/Signin/Signin";

import DisclaimerEditor from "./components/AdminComponents/Cms/Disclaimer/Disclaimer";
import ContactUsEditor from "./components/AdminComponents/Cms/ContactUs/ContactUsEditor";
import TermsEditor from "./components/AdminComponents/Cms/T&C/TermsEditor";
import RefundPolicyEditor from "./components/AdminComponents/Cms/RefundPolicy/RefundPolicyEditor";
import FaqEditor from "./components/AdminComponents/Cms/Faq/FaqEditor";
import ReviewsEditor from "./components/AdminComponents/Cms/Reviews/ReviewsEditor";

import MiscellaneousEditor from "./components/AdminComponents/Cms/Miscellaneous/MiscellaneousEditor";
import ProofEditor from "./components/AdminComponents/Cms/Proof/ProofEditor";
import TrainerEditor from "./components/AdminComponents/Cms/Trainer/TrainerEditor";

import SlotMachine from "./pages/mis";

import ListPackage from "./components/AdminComponents/Lms/ListPackage/ListPackage";
import ListBatch from "./components/AdminComponents/Lms/ListBatch/ListBatch";
import ListCourse from "./components/AdminComponents/Lms/ListCourse/ListCourse";
import ListModule from "./components/AdminComponents/Lms/ListModule/ListModule";
import PayoutClubTrainer from "./components/AdminComponents/Payouts/payout_club_trainer";
import PayoutClubMember from "./components/AdminComponents/Payouts/payout_club_memebr";
import PayoutClubAdmin from "./components/AdminComponents/Payouts/payout_club_admin";
import PayoutClubLeader from "./components/AdminComponents/Payouts/payout_club_leader";
import AdminTimesheet from "./Flows/SuperAdmin/Dashboard/Timesheet/AdminTimesheet";
import TrainerTimesheet from "./Flows/ClubTrainer/Dashboard/Timesheet/TrainerTimesheet";
import TrainerLayout from "./layouts/Trainer.layout";
import TrainerDashboard from "./Flows/ClubTrainer/Dashboard/EduProg/Edu";
import TrainerSignin from "./Flows/ClubTrainer/Signin/Signin";
import ClubLeaderLayout from "./layouts/ClubLeaderLayout";
import TeamMemberLayout from "./layouts/TeamMemberLayout";
import TeamLeaderLayout from "./layouts/TeamLeaderLayout";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Landing />} />
        <Route path="/club-leader" element={<ClubLeaderLayout />} />
        <Route path="/team-member" element={<TeamMemberLayout />} />
        <Route path="/team-leader" element={<TeamLeaderLayout />} />

        <Route
          path="/student/dashboard"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/dashboard/mypackage/course/:packageId"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/dashboard/mypackage/course/:packageId/modules"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/dashboard/courses/:packageId"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/dashboard/course/:courseId/modules"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/dashboard/video/:moduleId"
          element={
            <ProtectedRoute>
              <Student />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teamleader/dashboard"
          element={
            <ProtectedRoute>
              <TeamLeader />
            </ProtectedRoute>
          }
        />

        <Route
          path="/teammember/dashboard"
          element={
            <ProtectedRoute>
              <TeamMember />
            </ProtectedRoute>
          }
        />

        <Route
          path="/clubadmin/dashboard"
          element={
            <ProtectedRoute>
              <ClubAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trainer"
          element={
            <ProtectedRoute>
              <TrainerLayout />
            </ProtectedRoute>
          }
        >
          <Route path="timesheet" element={<TrainerTimesheet />} />
          <Route path="dashboard" element={<TrainerDashboard />} />
        </Route>
        {/* ----------- SuperAdmin Router ------------- */}
        <Route
          path="/superadmin"
          element={
            <ProtectedRoute>
              <SuperAdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<SuperDa />} />
          <Route path="dashboard" element={<SuperDa />} />

          <Route path="lms/package" element={<ListPackage />} />
          <Route path="lms/package/create" element={<CourseList />} />
          <Route path="lms/batch" element={<ListBatch />} />
          <Route path="lms/courses" element={<ListCourse />} />
          <Route path="lms/module" element={<ListModule />} />
          <Route path="gift" element={<Gift />} />
          <Route path="timesheet" element={<AdminTimesheet />} />

          <Route path="payout/club-trainer" element={<PayoutClubTrainer />} />
          <Route path="payout/club-member" element={<PayoutClubMember />} />
          <Route path="payout/club-admin" element={<PayoutClubAdmin />} />
          <Route path="payout/club-leader" element={<PayoutClubLeader />} />
          <Route path="payments" element={<Payments />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="sales" element={<SalesTarget />} />
          <Route path="leader" element={<StudentRegister />} />

          {/* CMS - Landing Page Routes */}
          <Route path="cms/landing/faq" element={<FaqEditor />} />
          <Route path="cms/landing/reviews" element={<ReviewsEditor />} />

          <Route path="cms/landing/proofs" element={<ProofEditor />} />
          <Route path="cms/landing/trainers" element={<TrainerEditor />} />

          {/* CMS - Footer Routes */}
          <Route path="cms/footer/disclaimer" element={<DisclaimerEditor />} />
          <Route path="cms/footer/contactus" element={<ContactUsEditor />} />
          <Route path="cms/footer/terms" element={<TermsEditor />} />
          <Route
            path="cms/footer/refundpolicy"
            element={<RefundPolicyEditor />}
          />
          <Route
            path="cms/footer/miscellaneous"
            element={<MiscellaneousEditor />}
          />

          {/* <Route path="sign" element={<SuperAdminSignin />} /> */}
        </Route>

        {/* <Route path="/trainer/dashboard"
          element={
            <ProtectedRoute>
              <Trainer />
            </ProtectedRoute>
          }
        /> */}

        <Route element={<MainLayout />}>
          <Route path="/product" element={<ProductPage />} />

          <Route path="/package" element={<CoursePage />} />
          <Route path="/package/:packageId" element={<LmsPackageDetails />} />
          <Route
            path="/package/:packageId/:batchId"
            element={<LmsBatchDetails />}
          />
          <Route
            path="/package/:packageId/:batchId/:courseId"
            element={<LmsCourseDetails />}
          />
          <Route
            path="/package/:packageId/:batchId/:courseId/:moduleId"
            element={<LmsModuleDetails />}
          />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/tnc" element={<TermsAndConditions />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />

          <Route path="/student" element={<Student />} />
          <Route path="/teamleader" element={<TeamLeader />} />
          <Route path="/teammember" element={<TeamMember />} />
          <Route path="/trainer" element={<Trainer />} />
          <Route path="/trainer/signin" element={<TrainerSignin />} />

          <Route path="/clubadmin" element={<ClubAdmin />} />
          <Route path="/superadmin/signin" element={<SuperAdminSignin />} />
          <Route path="/superadmin" element={<SuperAdmin />} />

          <Route path="/mis" element={<SlotMachine />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
